import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardTitle,
  Row,
  Alert, InputGroupText,
  InputGroup,
  Table,
  Col,
  Input,
  Button,
  FormGroup,
  Label,
  Form,
  Container,
  FormFeedback,
  NavbarText,
  NavbarBrand,
  Navbar,
  Nav,
  Modal,
  ModalBody,
} from "reactstrap";
import {
  VALIDATE_PAYMENT,
  PROCEED_PAYMENT,
  SELECT_CUSTOMER_URL,
  RESEND_PAYMENT_LINK,
  GET_AGENCY_CONVENIENCE_FEE_URL,
} from "../../../utils/APIEndpoints";
import { authHeader } from "../../../utils/functions/CoreFunctions";
import API from "../../../redux/actions/API";
import Swal from "sweetalert2";
import {  useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  NUMBER_SPACE_HYPHEN_ALLOWED,
  NUMBER_REGEX,
} from "../../../utils/constants/ValidationRegexs";
import {
  getAlertToast,
  detectCardType,
} from "../../../utils/functions/CustomFunctions";
import CustomLoader from "../../common/CustomLoader";
import cardTypes from "../../../utils/constants/ccImgTypes";
import { debounce } from "underscore";
import { getInvoiceDetails } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import defaultAvatar from "../../../assets/images/defaultImages/defaultAvatar.png";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function PaymentScreen() {
  const [query, setQuery] = useState(useQuery());
  // const [loading, setLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [linkExpired, setlinkExpired] = useState("Valid for a payment");
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [userCardType, setCardType] = useState("");
  const [isPasswordType, setPasswordInputType] = useState(true);
  const [masterId, setMasterId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [convenienceFee, setConvenienceFee] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [paymentToggle, setPaymentToggle] = useState(false);

  const togglePasswordType = () => {
    setPasswordInputType(!isPasswordType);
  };

  const modalToggle = () => {
    setPaymentToggle(!paymentToggle);
  };

  // Reducer
  const dispatch = useDispatch();

  const {
    loading = false,
    detail = {},
    error = false,
  } = useSelector((state) => state.InvoiceDetailReducer);

  const {
    actualInvoiceAmount = 0,
    agencyAddress = "",
    agencyLogo = "",
    companyName = "",
    couponDiscountPercentage = 0,
    customerId: customInvoiceId = 0,
    customerName = "",
    description = "",
    email = "",
    haskey = null,
    invoiceExpiryDate = "",
    invoiceItems = [],
    invoiceMasterId = 0,
    invoiceNumber = "",
    paymentAmount = 0,
    taxPercentage = 0,
    locationCodeId = 0,
    locationCode=0,
    agencyPhone = 0,
  } = detail;

  const calculateTaxAmount = () => {
    let taxamount = (actualInvoiceAmount / 100) * taxPercentage;
    return taxamount;
  };

  const calculateCouponAmount = () => {
    let couponAmount = (actualInvoiceAmount / 100) * couponDiscountPercentage;
    return couponAmount;
  };

  var currentDate = new Date();
  var currentMonth = parseInt(currentDate.getMonth()) + 1;
  var currentYear = currentDate.getFullYear().toString().substr(-2);

  let [customerValues, setCustomerValues] = useState(null);

  //Detect Entered Card Type
  const detectEnteredCardType = ({ target: { name, value } }) => {
    let trimmedValue = value.replace(/[^0-9]/g, "");
    if (trimmedValue) delayedQuery(trimmedValue);
    else setCardType("");
  };

  //Debounce
  const delayedQuery = useRef(
    debounce((cardNumber) => checkGivenCarType(cardNumber), 300)
  ).current;

  const checkGivenCarType = (cardNumber) => {
    let { cardType, isCardValid } = detectCardType(cardNumber);
    if (!isCardValid) setFieldError("cardNumber", "Invalid Card Number");
    setCardType(cardType);
  };

  const initialForm = {
    firstName: "",
    lastName: "",
    cardNumber: "",
    expirationMonth: "",
    expirationYear: "",
    cvv2: "",
  };
  //Formik
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    setFieldTouched,
    setFieldError,
    setFieldValue,
  } = useFormik(
    {
      initialValues: initialForm,
      enableReinitialize: true,
      validationSchema: Yup.object({
        firstName: Yup.string().required("First Name is required"),
        lastName: Yup.string().required("Last Name is required"),
        cardNumber: Yup.string()
          .trim()
          .required("Credit card number is required")
          .matches(NUMBER_SPACE_HYPHEN_ALLOWED, "Enter valid card number"),
        expirationMonth: Yup.string()
          .trim()
          .required("Expiration month is required")
          .when("expirationYear", (expirationYear, schema) => {
            return schema.test({
              test: (expirationMonth) =>
                (expirationYear == currentYear &&
                  expirationMonth >= currentMonth) ||
                (expirationYear !== currentYear && expirationMonth),
              message: "Invalid month",
            });
          }),
        expirationYear: Yup.string()
          .trim()
          .required("Expiration Year is required"),
        cvv2: Yup.string()
          .trim()
          // .test(
          //   "includes_spaces",
          //   "CVV should be numbers",
          //   (val) => !val.includes(" ")
          // )
          .required("CVV is required")
          .min(3, "CVV should be 3 or 4 digits")
          .max(4, "Four Digit is Maximum")
          .matches(NUMBER_REGEX, "Enter valid CVV number"),
        // .matches(
        //   userCardType === 'amex'
        //     ? FOUR_DIGIT_CODE_REGEX
        //     : THREE_DIGIT_CODE_REGEX,
        //   userCardType === 'amex'
        //     ? 'Enter valid four digits CVV number'
        //     : 'Enter valid three digits CVV number'
        // ),
      }),
      onSubmit: (values) => onPaymentClick(values),
    },
    ["expirationMonth"]
  );

  const {
    firstName = "",
    lastName = "",
    cardNumber = "",
    expirationMonth = "",
    expirationYear = "",
    cvv2 = "",
  } = values;

  //payment api
  const onPaymentClick = async (values) => {
   
    setPaymentLoading(true);
    try {
      const options = {
        method: "POST",
        url: PROCEED_PAYMENT,
        headers: authHeader(),
        data: {
          customerId: customerId,
          invoiceMasterId: masterId,
          firstName: firstName,
          lastName: lastName,
          address1: customerValues.address,
          city: customerValues.city,
          state: customerValues.state,
          zip: customerValues.zipCode,
          phone: customerValues.phoneNumber,
          email: customerValues.email,
          cardNumber: cardNumber.replace(/[^0-9]/g, ""),
          expirationMonth:
            expirationMonth.length < 2
              ? `0${expirationMonth}`
              : expirationMonth.toString(),
          expirationYear:
            expirationYear.length < 2
              ? `0${expirationYear}`
              : expirationYear.toString(),
          expirationYear: expirationYear,
          cvv2: cvv2,
          paymentType: "Card",
        },
      };
      Swal.fire(getAlertToast("success", "Please wait..."));
      var apiResponse = await API(options);
      const { status, message } = apiResponse.data;
      if (status === "Success") {
        Swal.fire(getAlertToast("success", message));
        setPaymentStatus(true);
        setPaymentToggle(true);
      } else if (status === "Error") {
        Swal.fire(getAlertToast("success", message));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setPaymentLoading(false);
    }
  };

  //check for validity
  const validatePayment = async () => {
    try {
      const options = {
        method: "POST",
        url: VALIDATE_PAYMENT,
        headers: authHeader(),
        data: {
          customerId: parseInt(query.get("customerId")),
          invoiceMasterId: parseInt(query.get("invoiceMasterId")),
          haskey: query.get("haskey"),
        },
      };
      Swal.fire(getAlertToast("success", "Please wait..."));
      var apiResponse = await API(options);
      const { status, message } = apiResponse.data;
      if (status === "Success") {
        Swal.fire(getAlertToast("success", message));
        setlinkExpired(message);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
    }
  };


  //check for validity
  const resendPaymentLink = async () => {
    try {
      const options = {
        method: "POST",
        url: RESEND_PAYMENT_LINK,
        headers: authHeader(),
        data: {
          customerId: customerId,
          invoiceMasterId: masterId,
        },
      };
      Swal.fire(getAlertToast("success", "Please wait..."));
      var apiResponse = await API(options);
      const { status, message } = apiResponse.data;
      if (status === "Success") {
        Swal.fire(getAlertToast("success", message));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
    }
  };

  //select Customer
  const loadValues = async (customerId) => {
    try {
     
      const options = {
        method: "GET",
        url: SELECT_CUSTOMER_URL,
        headers: authHeader(),
        params: { customerId: customerId },
      };
      const response = await API(options);
      const { status, data } = response.data;
      
      if (status === "Success") {
        
        setCustomerValues({
          customerName: data.customerName,
          email: data.email,
          phoneNumber: data.phoneNumber,
          address: data.address,
          state: data.state,
          zipCode: data.zipCode,
          city: data.city,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      // setLoading(false);
    }
  };

  //Get Convenience Fee
  const getConvenienceFee = async () => {
    // const certificate_and_variables_fee =
    //   parseFloat(paymentAmount) + parseFloat(variablesTotal);
    try {
      const apiOptions = {
        method: "GET",
        url: GET_AGENCY_CONVENIENCE_FEE_URL,
        headers: authHeader(),
        params: {
          locationCodeId: locationCodeId ? parseInt(locationCodeId) : parseInt(locationCode),
          amount: parseFloat(paymentAmount),
        },
      };
      const feeResponse = await API(apiOptions);
      const { status: feeResRtatus } = feeResponse.data;
      if (feeResRtatus === "Success") {
        const { ServiceFeeAmount = 0 } = feeResponse.data;
        setConvenienceFee(parseFloat(ServiceFeeAmount).toFixed(2));
        setTotalAmount(paymentAmount + parseFloat(ServiceFeeAmount));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
      }
    }
  };

  useEffect(() => {
    getConvenienceFee();
  }, [paymentAmount]);

  //Mount

  useEffect(() => {
    setMasterId(parseInt(query.get("invoiceMasterId")));
    setCustomerId(parseInt(query.get("customerId")));
    validatePayment();
  }, []);

  useEffect(() => {
    if (masterId) {
      dispatch(getInvoiceDetails(masterId));
    }
  }, [masterId]);

  useEffect(() => {
    if (customerId) {
      loadValues(customerId);
    }
  }, [customerId]);

  return (
    <div>
      <Container>
        <Row>
          <Col sm="12">
            <Card body>
              <CardTitle>
                <center>
                  <h4>Check your invoice Details Here</h4>
                </center>
              </CardTitle>
              <div
                style={{ backgroundColor: "#fff", border: "10px solid #fff" }}
              >
                {loading ? (
                  <center>
                    <CustomLoader loading={loading} />{" "}
                  </center>
                ) : error ? (
                  <div className="">
                    <center>
                      <h4>{detail}</h4>
                    </center>
                  </div>
                ) : (
                  <div className="preview-invoice-model">
                    <Navbar color="white">
                      <NavbarBrand href="/">
                        {" "}
                        <img
                        alt='logo'
                          src="https://payform.us/static/media/logo.0ced2d30.png"
                          className="logo mb-3 mt-3"
                        />
                      </NavbarBrand>
                      <Nav className="me-auto" navbar></Nav>
                      <NavbarText className="invoice-client-logo">
                        <img
                         alt='logo'
                          className="uploadImg"
                          src={agencyLogo || defaultAvatar}
                        />
                      </NavbarText>
                    </Navbar>
                    <section className="invoice-tem">
                      <div className="top">
                        <h4>Invoice from {companyName}</h4>

                        <p>Invoice: #{invoiceNumber}</p>
                      </div>
                      <div>
                        <Card body className="info-card">
                          <Row className="info">
                            <Col md="4">
                              <span>From</span>
                              <h5>{companyName || "-"}</h5>
                            </Col>
                            <Col md="4">
                              <span>Phone Number</span>
                              <h5>{agencyPhone || "-"}</h5>
                            </Col>

                            <Col md="4">
                              <span>Address</span>
                              <h5>{agencyAddress || "-"}</h5>
                            </Col>
                          </Row>
                          <Row className="info">
                            <Col md="4">
                              <span>Billed To</span>
                              <h5>{customerName || "-"}</h5>
                            </Col>
                            <Col md="4">
                              <span>Due Date</span>
                              <h5>{invoiceExpiryDate || "-"}</h5>
                            </Col>
                            <Col md="4">
                              <span>Amount Due</span>
                              <h5>${paymentAmount.toFixed(2)}</h5>
                            </Col>
                          </Row>
                        </Card>

                        <Card body className="summary-card">
                          <h6>Summary</h6>
                          <hr className="m-0 mb-2" />
                          <Table className="invoice-preview" bordered>
                            <thead>
                              <tr>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Item Price</th>
                                <th className="text-end">Total Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              {invoiceItems &&
                                JSON.parse(invoiceItems).map((data) => {
                                  const {
                                    itemDescription,
                                    quantity,
                                    individualAmount,
                                  } = data;
                                  return (
                                    <tr>
                                      <td>{itemDescription}</td>
                                      <td>{quantity}</td>
                                      <td>
                                        $
                                        {parseFloat(individualAmount).toFixed(
                                          2
                                        )}
                                      </td>
                                      <td className="text-end">
                                        $
                                        {parseFloat(
                                          quantity * individualAmount
                                        ).toFixed(2)}
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </Table>

                          <hr className="m-0 mb-2" />
                          <Row className="total-sec">
                            <Col md="12">
                              <div className="price-list">
                                <div className="list">
                                  <Label for="" className="">
                                    Sub Total
                                  </Label>
                                  <h6>${actualInvoiceAmount.toFixed(2)}</h6>
                                </div>
                                <div className="list">
                                  <Label for="" className="">
                                    Tax ({taxPercentage}%)
                                  </Label>

                                  <h6>${calculateTaxAmount().toFixed(2)}</h6>
                                </div>
                                <div className="list">
                                  <Label for="" className="">
                                    Discount ({couponDiscountPercentage}%)
                                  </Label>
                                  <h6>${calculateCouponAmount().toFixed(2)}</h6>
                                </div>
                                <div className="list">
                                  <Label for="" className="">
                                    Convenience Fee
                                  </Label>
                                  <h6>${convenienceFee}</h6>
                                </div>
                                <div className="list bold">
                                  <Label for="" className="">
                                    Amount Due
                                  </Label>

                                  <h6>${parseFloat(totalAmount).toFixed(2)}</h6>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    </section>
                  </div>
                )}
              </div>
              <br />
              {!paymentStatus ? (
                linkExpired == "Valid for a payment" ? (
                  <>
                    <CardTitle style={{ marginTop: "1rem" }}>
                      <h4>
                        <center>Payment</center>
                      </h4>
                    </CardTitle>
                    <Form onSubmit={handleSubmit}>
                      <FormGroup>
                        <Label for="exampleSelect">Payment Type</Label>
                        <Input
                          type="select"
                          name="select"
                          id="exampleSelect"
                          disabled
                        >
                          <option>Credit Card</option>
                        </Input>
                      </FormGroup>

                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label for="firstName">First Name</Label>
                            <Input
                              type="text"
                              name="firstName"
                              id="firstName"
                              invalid={
                                errors.firstName && touched.firstName
                                  ? true
                                  : false
                              }
                              onChange={({ target: { value } }) => {
                                setFieldTouched("firstName", true);
                                setFieldValue("firstName", value);
                              }}
                              value={firstName}
                              placeholder="First Name"
                            />
                            <FormFeedback>
                              {errors.firstName && touched.firstName
                                ? errors.firstName
                                : ""}
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label for="lastName">Last Name</Label>
                            <Input
                              type="text"
                              name="lastName"
                              id="lastName"
                              invalid={
                                errors.lastName && touched.lastName
                                  ? true
                                  : false
                              }
                              onChange={({ target: { value } }) => {
                                setFieldTouched("lastName", true);
                                setFieldValue("lastName", value);
                              }}
                              value={lastName}
                              placeholder="last Name"
                            />
                            <FormFeedback>
                              {errors.lastName && touched.lastName
                                ? errors.lastName
                                : ""}
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="9">
                          <FormGroup>
                            <Label for="CreditCard">Card Number</Label>
                            <Input
                              type="text"
                              name="cardNumber"
                              id="CreditCard"
                              placeholder="Enter credit card number"
                              invalid={
                                errors.cardNumber && touched.cardNumber
                                  ? true
                                  : false
                              }
                              onChange={(event) => {
                                setFieldTouched("cardNumber", true);
                                handleChange(event);
                                detectEnteredCardType(event);
                              }}
                              value={cardNumber}
                            />
                            <FormFeedback>
                              {errors.cardNumber && touched.cardNumber
                                ? errors.cardNumber
                                : ""}
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          {userCardType && (
                            <img
                              style={{
                                width: "60px",
                                height: "40px",
                                marginLeft: "-7px",
                                marginTop: "30px"
                              }}
                              src={cardTypes[userCardType]}
                              alt="no data"
                            />
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col md="7">
                          <FormGroup>
                            <Label for="Expiration">Expiration</Label>
                            <Row>
                              <Col md="6">
                                <Input
                                  type="number"
                                  max={12}
                                  min={1}
                                  step={1}
                                  name="expirationMonth"
                                  id="Expiration"
                                  invalid={
                                    errors.expirationMonth &&
                                    touched.expirationMonth
                                      ? true
                                      : false
                                  }
                                  onChange={({ target: { value } }) => {
                                    setFieldTouched("expirationMonth", true);
                                    if (value.length <= 2) {
                                      setFieldValue("expirationMonth", value);
                                    } else {
                                      return;
                                    }
                                  }}
                                  value={expirationMonth}
                                  placeholder="MM"
                                />
                                <FormFeedback>
                                  {errors.expirationMonth &&
                                  touched.expirationMonth
                                    ? errors.expirationMonth
                                    : ""}
                                </FormFeedback>
                              </Col>
                              <Col md="6">
                                <Input
                                  type="number"
                                  min={currentYear}
                                  step={1}
                                  name="expirationYear"
                                  id="expirationYear"
                                  placeholder="YY"
                                  invalid={
                                    errors.expirationYear &&
                                    touched.expirationYear
                                      ? true
                                      : false
                                  }
                                  onChange={({ target: { value } }) => {
                                    setFieldTouched("expirationYear", true);
                                    if (value.length <= 2) {
                                      setFieldValue("expirationYear", value);
                                    } else {
                                      return;
                                    }
                                  }}
                                  value={expirationYear}
                                />
                                <FormFeedback>
                                  {errors.expirationYear &&
                                  touched.expirationYear
                                    ? errors.expirationYear
                                    : ""}
                                </FormFeedback>
                              </Col>
                            </Row>
                          </FormGroup>
                        </Col>
                        <Col md="5">
                          <FormGroup>
                            <Label for="CVV">CVV</Label>
                            <InputGroup>
                              <Input
                                type={isPasswordType ? "password" : "text"}
                                name="cvv2"
                                id="CVV"
                                maxLength={4}
                                invalid={
                                  errors.cvv2 && touched.cvv2 ? true : false
                                }
                                onChange={(event) => {
                                  setFieldTouched("cvv2", true);
                                  handleChange(event);
                                }}
                                value={cvv2}
                                placeholder="CVV"
                              />
                              
                                <InputGroupText
                                  onClick={togglePasswordType}
                                  style={{ cursor: "pointer" }}
                                >
                                  {isPasswordType ? (
                                    <i className="fas fa-eye-slash" />
                                  ) : (
                                    <i className="fas fa-eye" />
                                  )}
                                </InputGroupText>
                              
                              <FormFeedback>
                                {errors.cvv2 && touched.cvv2 ? errors.cvv2 : ""}
                              </FormFeedback>
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <div className="m-auto mt-3">
                          <Button
                            type="submit"
                            disabled={paymentLoading}
                            color="primary"
                          >
                            {paymentLoading && (
                              <CustomLoader loading={paymentLoading} />
                            )}
                            Pay ${parseFloat(totalAmount).toFixed(2)}
                          </Button>
                        </div>
                      </Row>
                    </Form>
                  </>
                ) : (
                  <>
                    <h4>Your Payment Link is Expired!</h4>
                    <Button
                      onClick={resendPaymentLink}
                      style={{ width: "maxContent", margin: "auto" }}
                    >
                      Click Here to Resend
                    </Button>
                  </>
                )
              ) : (
                <div>
                  {paymentToggle && (
                    <Modal centered isOpen={paymentToggle} toggle={modalToggle}>
                      <ModalBody>
                        <div style={{ color: "#155724" }}>
                          <h4 className="alert-heading">
                            <center>Payment Success!</center>
                          </h4>
                          <center>
                            <h4>
                              You have successfully paid $
                              {parseFloat(totalAmount).toFixed(2)}
                            </h4>
                            <p>
                              Please check your email for your receipt and to
                              view a copy of your invoice
                            </p>

                            <Button color="secondary" onClick={modalToggle}>
                              Close
                            </Button>
                          </center>
                        </div>
                      </ModalBody>
                    </Modal>
                  )}
                  <Alert color="success">
                    <div style={{ fontWeight: "900", fontSize: "larger" }}>
                      <center>Paid</center>
                    </div>
                  </Alert>
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PaymentScreen;

